export default __webpack_public_path__ + "static/media/heatTreatment.cad51961.webp";